import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { SessionStorageService } from './session-storage.service';
import { AwsApiService } from './aws-api.service';
import { catchError, delay, tap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  myAccountWindow?: Window;

  constructor(
    private http: HttpClient,
    private awsApi: AwsApiService,
    private sessionStorage: SessionStorageService
  ) {}

  logout(afterLogout: any) {
    if (this.myAccountWindow) {
      this.myAccountWindow.close();
    }

    const user = this.sessionStorage.getUser(),
      organization = this.sessionStorage.getOrganization();
    if (!user || !organization) {
      return afterLogout && afterLogout();
    }

    const signouts = [];
    // Log out of each app that supports it
    _.forEach(environment.applications, app => {
      if (app.getLogoutRequest) {
        const request = app.getLogoutRequest(this.sessionStorage);
        if (request.useIframe) {
          if (request.post) {
            signouts.push(of(
              window['iframeLogout'].src = request.post.url
            ).pipe(
              delay(1000)
            ))
          } else if (request.get) {
            signouts.push(of(
              window['iframeLogout'].src = request.get.url
            ).pipe(
              delay(1000)
            ));
          }
        }
        else {
          if (request.post) {
            signouts.push(this.http.post(request.post.url, request.post.body));
          } else if (request.get) {
            signouts.push(this.http.get(request.get.url));
          }
        }
      }
    });

    const cognitoSignout = () => {
      this.awsApi
        .cognito()
        .globalSignOut({
          AccessToken: this.sessionStorage.getAccessToken()
        })
        .promise()
        .then(afterLogout, afterLogout);
    };

    const nextSignout = () => {
      const signout = signouts.pop();
      if (signout) {
        return signout.subscribe(nextSignout, nextSignout);
      }
      return cognitoSignout();
    };

    nextSignout();
  }
}
